import mujeeb from "./AboutImages/mujeeb.png";

const teamMembers = [
  {
    name: "Mujeeb Dange",
    role: "Founder & Managing Director",
    image: mujeeb,
    bio: "Mujeeb is a tourism and hospitality professional with over 3 years of global industry experience. He has worked across international markets, gaining strong exposure to travel operations and destination management. His expertise includes tour planning, itinerary design, and customer relationship management. He efficiently handles both leisure and corporate travel requirements. Mujeeb has a solid understanding of global travel trends and service standards. He is known for delivering seamless, customer-focused travel experiences.",
  },
  // {
  //   name: "Reshma",
  //   role: "Operations Head",
  //   image:
  //     "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=800&q=80",
  //   bio: "Rahul is an expert in adventure travel — from Himalayan treks to desert safaris. He manages ground operations globally, focusing on safety, thrill, and exceptional coordination for every tour.",
  // },
];

export default teamMembers;
